// src/features/services/components/ServiceWorkspaceHeader.tsx
import { PageHeader, formatPersianNumber } from '../../../app/components/foundation';
import type { Service } from '../types/service.types';
import { ServiceStatusBadge } from './ServiceStatusBadge';

export interface ServiceWorkspaceHeaderProps {
  service: Service;
}

/**
 * Top-of-page header for the service workspace. Unlike
 * CustomerWorkspaceHeader (a custom Card layout), this phase's brief
 * calls for reusing the shared PageHeader primitive directly: service
 * name as the title, id as supporting description, and the status
 * badge in the actions slot (rendered inline with the title, same as
 * every other feature's PageHeader usage).
 */
export function ServiceWorkspaceHeader({ service }: ServiceWorkspaceHeaderProps) {
  return (
    <PageHeader
      title={service.name}
      description={`شناسه سرویس: ${formatPersianNumber(service.id)}`}
      actions={<ServiceStatusBadge status={service.status} />}
    />
  );
}
